import { UserService } from "@/services";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import { IUserModel } from "@/models";
import { ResponseModel } from "@/models";
import dayjs from "dayjs";

const allowedAccess = process.env.VUE_APP_ROLE.split(",");

export interface IAuthModuleState {
  isAuthenticated: boolean;
  isAdmin: boolean;
  currentUser?: IUserModel | undefined;
  checkUserAuthentication(): void;
}
@Module({
  namespaced: true,
  name: "auth"
})
export class Auth extends VuexModule implements IAuthModuleState {
  private _isAuthenticated: boolean = false;
  private _currentUser?: IUserModel = undefined;
  private _isAdmin: boolean = false;
  get isAdmin(): boolean {
    return this._isAdmin;
  }
  get isAuthenticated(): boolean {
    return this._isAuthenticated;
  }

  get currentUser(): IUserModel | undefined {
    return this._currentUser;
  }

  @Mutation
  private setLogin(user: IUserModel) {
    this._currentUser = user;
    this._isAuthenticated = true;
    this._isAdmin = allowedAccess.includes(user.role);
  }

  @Mutation
  private setLogout(user: IUserModel) {
    this._currentUser = undefined;
    this._isAuthenticated = false;
    this._isAdmin = false;
  }

  @Mutation
  public loadAuthenticatedUser({ status, data }: ResponseModel<IUserModel>) {
    if (status === 200) {
      this._isAuthenticated = true;
      this._currentUser = data;
      this._isAdmin = allowedAccess.includes(data.role);
    } else {
      this._isAuthenticated = false;
      this._currentUser = undefined;
      this._isAdmin = false;
    }
  }

  @Action({ commit: "loadAuthenticatedUser" })
  async checkUserAuthentication() {
    let response = await UserService.IsAuthenticated();

    if (response.status === 200 && response.data) {
      let userResponse = await UserService.GetUserLoginInfo();
      return userResponse;
    }
    return { status: 404, data: undefined };
  }

  @Action({ commit: "setLogin" })
  async login(user: IUserModel) {
    return user;
  }

  @Action({ commit: "setLogout" })
  logout() {
    return undefined;
  }
}
